import React from 'react';
import PropTypes from 'prop-types';

import Lottie from 'react-lottie';
import {
  Modal,
  ModalContent,
  ModalDescription,
  Conditional,
  Text,
  Button,
  Grid,
  Row,
  Column,
} from '@cashfree-intl/coherent';

import * as animationData from 'animation/settle-now-success.json';
import freetrial from '../../../images/free-trial-tag.svg';
import CustomIcon from '../../../components/CustomIcons';

const SettleNowSuccessModal = ({
  closeModal,
  settleNowStatusObj,
  modalData,
  isFreeTrialActive,
}) => {
  const defaultOptions = {
    loop: false,
    animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  const isSettlementSuccess = settleNowStatusObj.type === 'success';

  return (
    <Modal $maxWidth={480} open>
      <ModalContent className="p-4">
        <ModalDescription className={isSettlementSuccess ? 'mr-top-n24' : ''}>
          <Conditional if={isFreeTrialActive}>
            <img
              src={freetrial}
              alt="Free Trial Mode"
              className="free-trial-tag"
            />
          </Conditional>
          {isSettlementSuccess ? (
            <Lottie options={defaultOptions} height={120} width={120} />
          ) : (
            <div className="text-center mb-2">
              <CustomIcon componentName="FAILED" size="lg" />
            </div>
          )}
          <div className="text-center">
            <Text variant="h20" className="mb-1">
              {settleNowStatusObj.title}
            </Text>
            <p className="text-light">
              {modalData.description || settleNowStatusObj.description}
            </p>
          </div>
          <Grid
            className={`alert-modal content-wrapper ${settleNowStatusObj.type}`}
          >
            {Object.keys(settleNowStatusObj.content).map(key => (
              <Row columns={2} key={key}>
                <Column>
                  <span className="text-light">
                    {settleNowStatusObj.content[key]}
                  </span>
                </Column>
                <Column>
                  <span className="text-dark w-600">{modalData[key]}</span>
                </Column>
              </Row>
            ))}
          </Grid>
          {/* </StyledWrapper> */}
          <div
            className={`mt-4 text-center ${
              isSettlementSuccess ? 'mr-btm-8' : ''
            }`}
          >
            <Button
              primary
              onClick={closeModal}
              data-event-name="Primary_Button_Close"
            >
              Close
            </Button>
          </div>
        </ModalDescription>
      </ModalContent>
    </Modal>
  );
};

SettleNowSuccessModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  settleNowStatusObj: PropTypes.object.isRequired,
  modalData: PropTypes.object.isRequired,
  isFreeTrialActive: PropTypes.bool,
};

export default SettleNowSuccessModal;
